import React from 'react';
import cx from 'classnames';
import { useGetWKDALeadCookie } from '@wkda/funnel-components';
import { useGetCustomerBannerName, useGetCustomerBannerProps } from '../hooks/useBannerReturnCustomer';
import { renderBannerChildren } from './renderBannerChildren';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerReturnCustomer = /*#__PURE__*/React.memo(_ref => {
  let {
    children = renderBannerChildren,
    className
  } = _ref;
  const bannerName = useGetCustomerBannerName();
  const bannerProps = useGetCustomerBannerProps(bannerName);
  let dynamicClassName = '';
  if (!bannerName || !hasBannerProps(bannerProps)) {
    return null;
  }
  if (bannerProps.__type === 'L2A') {
    const {
      isSelfEvaluationCompleted,
      isRiskFree
    } = bannerProps;
    if (!isSelfEvaluationCompleted) {
      dynamicClassName = isRiskFree ? 'risk-free-banner' : 'balance-sheet-banner';
    }
  }
  return /*#__PURE__*/_jsx("div", {
    className: cx('banner-return-customer', dynamicClassName, className),
    children: children({
      bannerName,
      bannerProps
    })
  });
});
function hasBannerProps(props) {
  return props !== null;
}
function BannerReturnCustomerWrapper(props) {
  const wkdaLead = useGetWKDALeadCookie();
  return wkdaLead ? /*#__PURE__*/_jsx(BannerReturnCustomer, {
    ...props
  }) : null;
}
export { BannerReturnCustomerWrapper as BannerReturnCustomer };